/* eslint semi:0 */
import userStore from '../../stores/userStore'
import { queryString } from '../../../utils/window'
import { getIsBot } from '../../../utils/ua'
import { getInfluencerId } from '../../../utils/pageContext'
import { get as getFromPdo } from '../../../application/pageDataObject'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { sendData as sendActionCounterData } from '../../../providers/actionCounter/currentPostActionCounterProvider'

const PAGE_DATA_OBJECT_FALLBACK = {
  post: {
    // Defaults for failed pageDataObject parsing
    id: null,
    author: {
      id: null,
      league: null,
    },
  },
  page: {},
}

export default class ActionCounterService extends AnalyticsBaseService {
  constructor(options = {}) {
    super(options)
    this.facebookShare = this.twitterShare = this.whatsappShare = this.socialShare
    let post = getFromPdo('post', PAGE_DATA_OBJECT_FALLBACK.post)
    let { author, action_counter_tag: actionCounterTag } = post
    this.basicPostAndAuthorData = {
      post: post.id,
      author: author.id,
      league: actionCounterTag,
    }
    if (userStore.state.id) {
      this.basicPostAndAuthorData.user = userStore.state.id
    }
  }

  get className() {
    return 'ActionCounterService'
  }

  routeChanged(action) {
    //Empty override to prevent a read report on slideshows on each slide change
  }

  pageViewed() {
    if (this.shouldReportPageview()) {
      this.trackEvent('reads', this.pageViewData)
    }
  }

  shouldReportPageview() {
    let postId = getFromPdo('post.id', false)
    if (postId === false) {
      return false
    }
    return userStore.recentReads[postId].readsCount <= 1
  }

  get pageViewData() {
    let { post, page } = Object.assign(PAGE_DATA_OBJECT_FALLBACK, {
      post: getFromPdo('post', PAGE_DATA_OBJECT_FALLBACK.post),
      page: getFromPdo('page', PAGE_DATA_OBJECT_FALLBACK.page),
    })
    let { author } = post
    let data = Object.assign({}, this.basicPostAndAuthorData, {
      locale: page.locale,
      domain: page.site,
      aid: getInfluencerId() || queryString.af,
      featured_to_site: post.featured_to_site, // eslint-disable-line camelcase
    })
    return data
  }

  socialShare() {
    this.trackEvent('shares', this.basicPostAndAuthorData)
  }

  trackEvent(type, params) {
    if (!getIsBot()) {
      this.logAnalytics(type, params)
      sendActionCounterData(type, params)
    }
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/actionCounterService.js